/**
 * Viewport intro: [data-r3nu-intro-reveal] sections reveal each "chunk" only when
 * that element scrolls into view. Adds .r3nu-chunk--in per target (not one class on the whole section).
 *
 * rootMargin 0 and threshold 0: animation starts as soon as any part of a chunk meets the
 * real viewport. Sub-viewport insets (previously used) made chunks wait until they sat much higher
 * in the window. Chunks not yet in view stay hidden with :not(.r3nu-chunk--in) in CSS.
 */
(function () {
  var ATTR = 'data-r3nu-intro-reveal';
  var CHUNK_IN = 'r3nu-chunk--in';
  var INIT_ATTR = 'data-r3nu-intro-reveal-init';
  function getChunkRootMargin() {
    if (window.R3NU && window.R3NU.reveal && window.R3NU.reveal.getRootMargin) {
      return window.R3NU.reveal.getRootMargin();
    }
    return '0px 0px 10% 0px';
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pushIf(list, el) {
    if (el && el.nodeType === 1) list.push(el);
  }

  function isProductAccordionChunk(el) {
    return !!(el && el.classList && el.classList.contains('product__accordion--r3nu'));
  }

  /** Reveal consecutive product accordions together (only the leader is observed). */
  function revealProductAccordionGroup(leader) {
    if (!isProductAccordionChunk(leader)) return;
    var el = leader;
    while (el && isProductAccordionChunk(el)) {
      el.classList.add(CHUNK_IN);
      el = el.nextElementSibling;
    }
  }

  /** Tight stagger for accordion stack — follows the block above, not full nth-child chain. */
  function setProductAccordionDelayIndices(root) {
    if (!root || !root.tagName || root.tagName.toUpperCase() !== 'PRODUCT-INFO') return;
    var container = root.querySelector('.product--r3nu .product__info-container');
    if (!container) return;
    var hasBreadcrumb = !!root.querySelector('.product-r3nu-breadcrumb');

    container.querySelectorAll(':scope > .product__accordion--r3nu').forEach(function (acc) {
      var prev = acc.previousElementSibling;
      if (prev && isProductAccordionChunk(prev)) {
        acc.style.removeProperty('--r3nu-chunk-delay-index');
        acc.style.removeProperty('--r3nu-accordion-sibling-offset');
        return;
      }

      var delayIndex = 2;

      acc.style.setProperty('--r3nu-chunk-delay-index', String(delayIndex));
      acc.style.setProperty('--r3nu-accordion-sibling-offset', '0');

      var next = acc.nextElementSibling;
      var sib = 1;
      while (next && isProductAccordionChunk(next)) {
        next.style.setProperty('--r3nu-chunk-delay-index', String(delayIndex));
        next.style.setProperty('--r3nu-accordion-sibling-offset', String(sib * 0.35));
        sib += 1;
        next = next.nextElementSibling;
      }
    });
  }

  function clearProductAccordionDelayIndices(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product--r3nu .product__info-container > .product__accordion--r3nu').forEach(
      function (acc) {
        acc.style.removeProperty('--r3nu-chunk-delay-index');
        acc.style.removeProperty('--r3nu-accordion-sibling-offset');
      }
    );
  }

  /**
   * @returns {Array|null} list of elements to reveal independently, or null to use legacy whole-section (none currently)
   */
  function collectChunkElements(root) {
    var list = [];
    var tag = root.tagName && root.tagName.toUpperCase();

    if (tag === 'PRODUCT-INFO') {
      pushIf(list, root.querySelector('.page-width > .product-r3nu-breadcrumb'));
      pushIf(list, root.querySelector('.product--r3nu .product__media-wrapper media-gallery'));
      root.querySelectorAll('.product--r3nu .product__info-container > *').forEach(function (n) {
        if (isProductAccordionChunk(n)) {
          var prev = n.previousElementSibling;
          if (prev && isProductAccordionChunk(prev)) return;
        }
        list.push(n);
      });
      return list.length ? list : null;
    }

    if (root.classList && root.classList.contains('r3nu-why')) {
      pushIf(list, root.querySelector('.r3nu-why__eyebrow'));
      pushIf(list, root.querySelector('.r3nu-why__heading'));
      pushIf(list, root.querySelector('.r3nu-why__subtext'));
      root.querySelectorAll('.r3nu-why__mosaic .r3nu-why-card').forEach(function (n) {
        list.push(n);
      });
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-tg')) {
      pushIf(list, root.querySelector('.r3nu-tg__heading'));
      pushIf(list, root.querySelector('.r3nu-tg__header .r3nu-review-summary__text'));
      root.querySelectorAll('.r3nu-tg__card').forEach(function (card) {
        pushIf(list, card.querySelector('.r3nu-tg__stars'));
        var tgLines = card.querySelectorAll('.r3nu-tg__quote-line');
        if (tgLines && tgLines.length) {
          tgLines.forEach(function (n) {
            list.push(n);
          });
        } else {
          pushIf(list, card.querySelector('blockquote.r3nu-tg__quote'));
        }
        pushIf(list, card.querySelector('.r3nu-tg__avatar-block'));
      });
      return list.length ? list : null;
    }

    if (root.classList.contains('related-products-intro')) {
      pushIf(list, root.querySelector('.related-products__heading'));
      root.querySelectorAll('.related-products .grid__item').forEach(function (n) {
        list.push(n);
      });
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-logo-showcase')) {
      pushIf(list, root.querySelector('.r3nu-logo-showcase__col--copy'));
      pushIf(list, root.querySelector('.r3nu-logo-showcase__col--logos'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-cta-recovery')) {
      pushIf(list, root.querySelector('.r3nu-cta-recovery__heading'));
      pushIf(list, root.querySelector('.r3nu-cta-recovery__subtext'));
      pushIf(list, root.querySelector('.r3nu-cta-recovery__actions'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-cta-heritage')) {
      pushIf(list, root.querySelector('.r3nu-cta-heritage__kicker'));
      pushIf(list, root.querySelector('.r3nu-cta-heritage__text'));
      pushIf(list, root.querySelector('.r3nu-cta-heritage__link'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-rcs')) {
      pushIf(list, root.querySelector('.r3nu-rcs__eyebrow'));
      pushIf(list, root.querySelector('.r3nu-rcs__heading'));
      pushIf(list, root.querySelector('.r3nu-rcs__subtext'));
      pushIf(list, root.querySelector('.r3nu-rcs__track'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-ppi')) {
      var ppiItems = root.querySelectorAll('.r3nu-ppi__item');
      if (ppiItems && ppiItems.length) {
        ppiItems.forEach(function (n) {
          list.push(n);
        });
      } else {
        pushIf(list, root.querySelector('.r3nu-ppi__content'));
      }
      pushIf(list, root.querySelector('.r3nu-ppi__media'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-testimonial')) {
      var tsFirst = root.querySelector('.r3nu-testimonial__slide');
      if (tsFirst) {
        pushIf(list, tsFirst.querySelector('.r3nu-testimonial__stars'));
        var tsLines = tsFirst.querySelectorAll('.r3nu-testimonial__quote-line');
        if (tsLines && tsLines.length) {
          tsLines.forEach(function (n) {
            list.push(n);
          });
        } else {
          pushIf(list, tsFirst.querySelector('blockquote.r3nu-testimonial__quote'));
        }
        pushIf(list, tsFirst.querySelector('.r3nu-testimonial__meta'));
      }
      pushIf(list, root.querySelector('.r3nu-testimonial__arrow--prev'));
      pushIf(list, root.querySelector('.r3nu-testimonial__arrow--next'));
      pushIf(list, root.querySelector('.r3nu-testimonial__dots'));
      if (!list.length) {
        pushIf(list, root.querySelector('.r3nu-testimonial__component'));
      }
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-our-story')) {
      pushIf(list, root.querySelector('.r3nu-our-story__eyebrow'));
      pushIf(list, root.querySelector('.r3nu-our-story__body'));
      pushIf(list, root.querySelector('.r3nu-our-story__media'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-brand-philosophy')) {
      pushIf(list, root.querySelector('.r3nu-brand-philosophy__heading'));
      pushIf(list, root.querySelector('.r3nu-brand-philosophy__body'));
      pushIf(list, root.querySelector('.r3nu-brand-philosophy__media'));
      root.querySelectorAll('.r3nu-brand-philosophy__logo-item').forEach(function (n) {
        list.push(n);
      });
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-product-page-header')) {
      pushIf(list, root.querySelector('.r3nu-product-page-header__media'));
      pushIf(list, root.querySelector('.r3nu-product-page-header__content'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-blog-featured-hero')) {
      var mbf = root.querySelector('.r3nu-blog-featured-hero__media');
      if (mbf) pushIf(list, mbf);
      pushIf(list, root.querySelector('.r3nu-blog-featured-hero__badge'));
      pushIf(list, root.querySelector('.r3nu-blog-featured-hero__heading'));
      pushIf(list, root.querySelector('.r3nu-blog-featured-hero__excerpt'));
      pushIf(list, root.querySelector('.r3nu-blog-featured-hero__btn'));
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-blog-grid')) {
      pushIf(list, root.querySelector('.r3nu-blog-grid__header'));
      pushIf(list, root.querySelector('.r3nu-blog-grid__filters-outer'));
      var blogGridG = root.querySelector('.r3nu-blog-grid__grid');
      if (blogGridG) {
        list.push(blogGridG);
      } else {
        pushIf(list, root.querySelector('.r3nu-blog-grid__empty'));
      }
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-article-editorial')) {
      pushIf(list, root.querySelector('.r3nu-article-editorial__hero-wrap'));
      root.querySelectorAll('.r3nu-article-editorial__stack').forEach(function (aeStack) {
        for (var aei = 0; aei < aeStack.children.length; aei++) {
          var aeCh = aeStack.children[aei];
          if (aeCh.nodeType === 1) list.push(aeCh);
        }
      });
      pushIf(list, root.querySelector('.r3nu-article-editorial__intro'));
      return list.length ? list : null;
    }

    if (root.classList.contains('shipping-delivery')) {
      pushIf(list, root.querySelector('.shipping-delivery__eyebrow'));
      pushIf(list, root.querySelector('.shipping-delivery__heading'));
      pushIf(list, root.querySelector('.shipping-delivery__subtext'));
      root.querySelectorAll('.shipping-delivery__card').forEach(function (n) {
        list.push(n);
      });
      return list.length ? list : null;
    }

    if (root.classList.contains('r3nu-related-articles')) {
      pushIf(list, root.querySelector('.r3nu-related-articles__header'));
      var raCards = root.querySelector('.r3nu-related-articles__cards');
      if (raCards) {
        for (var ri = 0; ri < raCards.children.length; ri++) {
          var raRow = raCards.children[ri];
          if (raRow.nodeType === 1) list.push(raRow);
        }
      }
      pushIf(list, root.querySelector('.r3nu-related-articles__see-all-wrap'));
      pushIf(list, root.querySelector('.r3nu-related-articles__empty'));
      return list.length ? list : null;
    }

    return null;
  }

  function revealChunkElement(el) {
    if (!el) return;
    if (isProductAccordionChunk(el)) {
      revealProductAccordionGroup(el);
      return;
    }
    el.classList.add(CHUNK_IN);
  }

  /** True if element’s border box overlaps the visual viewport (entering from top or bottom). */
  function chunkElementIntersectsViewport(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var vw = window.innerWidth || 0;
    return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
  }

  /**
   * @param {IntersectionObserver} io
   * @param {IntersectionObserverEntry} entry
   */
  function processIntersectionEntry(io, entry) {
    if (!entry || !entry.target) return;
    var t = entry.target;
    // Scroll-up / compositor: IO may report no intersection while geometry shows overlap.
    var ioSaysIn =
      entry.isIntersecting || entry.intersectionRatio > 0 || chunkElementIntersectsViewport(t);
    if (!ioSaysIn) return;
    if (isProductAccordionChunk(t)) {
      revealProductAccordionGroup(t);
    } else {
      t.classList.add(CHUNK_IN);
    }
    try {
      io.unobserve(t);
    } catch (e) {}
  }

  function detachRoot(root) {
    if (root._r3nuChunkIOs && root._r3nuChunkIOs.length) {
      root._r3nuChunkIOs.forEach(function (obs) {
        try {
          obs.disconnect();
        } catch (e) {}
      });
      root._r3nuChunkIOs = null;
    }
  }

  function clearChunksInClass(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.' + CHUNK_IN).forEach(function (el) {
      el.classList.remove(CHUNK_IN);
    });
  }

  function teardown(root) {
    if (!root) return;
    detachRoot(root);
    clearChunksInClass(root);
    clearProductAccordionDelayIndices(root);
    root.removeAttribute(INIT_ATTR);
  }

  function init(root) {
    if (!root || !root.hasAttribute(ATTR) || root.getAttribute(INIT_ATTR)) return;

    root.setAttribute(INIT_ATTR, 'true');

    if (root.tagName && root.tagName.toUpperCase() === 'PRODUCT-INFO') {
      setProductAccordionDelayIndices(root);
    }

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      var chunksD = collectChunkElements(root);
      if (chunksD && chunksD.length) {
        chunksD.forEach(revealChunkElement);
      } else {
        clearChunksInClass(root);
        revealChunkElement(root);
      }
      return;
    }

    if (prefersReducedMotion()) {
      var chunksRM = collectChunkElements(root);
      if (chunksRM && chunksRM.length) {
        chunksRM.forEach(revealChunkElement);
      } else {
        revealChunkElement(root);
      }
      return;
    }

    var chunks = collectChunkElements(root);
    if (!chunks || !chunks.length) {
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          processIntersectionEntry(io, entry);
        });
      },
      { threshold: [0, 0.01, 0.05, 0.1, 0.25, 0.5, 1], rootMargin: getChunkRootMargin() }
    );
    root._r3nuChunkIOs = [io];

    chunks.forEach(function (el) {
      if (el.offsetHeight < 1 && el.getBoundingClientRect) {
        var r = el.getBoundingClientRect();
        if (r.width < 1 && r.height < 1) {
          el.classList.add(CHUNK_IN);
          return;
        }
      }
      io.observe(el);
    });

    scheduleScrollSync();
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll('[' + ATTR + ']').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t || !t.querySelectorAll) return;
    t.querySelectorAll('[' + ATTR + ']').forEach(function (el) {
      teardown(el);
    });
  });

  function reinit(root) {
    if (!root || !root.hasAttribute(ATTR)) return;
    teardown(root);
    init(root);
  }

  window.R3NU = window.R3NU || {};
  window.R3NU.introRevealReinit = reinit;
  window.R3NU.introChunkMargin = { hero: getChunkRootMargin(), scroll: getChunkRootMargin() };
  window.r3nuIntroRevealReinit = reinit;
  window.r3nuIntroChunkMargin = window.R3NU.introChunkMargin;

  function syncChunksAfterScrollRestore() {
    if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
    document.querySelectorAll('[' + INIT_ATTR + ']').forEach(function (root) {
      if (!root.hasAttribute(ATTR)) return;
      if (prefersReducedMotion()) return;
      var ios = root._r3nuChunkIOs;
      if (!ios || !ios.length) return;
      var io = ios[0];
      try {
        var pending = io.takeRecords();
        if (pending && pending.length) {
          pending.forEach(function (entry) {
            processIntersectionEntry(io, entry);
          });
        }
      } catch (e) {}
      var chunks = collectChunkElements(root);
      if (!chunks || !chunks.length) return;
      chunks.forEach(function (el) {
        if (el.classList.contains(CHUNK_IN)) return;
        if (el.offsetHeight < 1 && el.getBoundingClientRect) {
          var r0 = el.getBoundingClientRect();
          if (r0.width < 1 && r0.height < 1) {
            el.classList.add(CHUNK_IN);
            try {
              io.unobserve(el);
            } catch (e) {}
            return;
          }
        }
        if (chunkElementIntersectsViewport(el)) {
          if (isProductAccordionChunk(el)) {
            revealProductAccordionGroup(el);
          } else {
            el.classList.add(CHUNK_IN);
          }
          try {
            io.unobserve(el);
          } catch (e) {}
        }
      });
    });
  }

  /** Slow scroll: IO updates can lag; flush pending entries + geometry on scroll/resize (rAF-throttled). */
  var scrollSyncScheduled = false;
  function scheduleScrollSync() {
    if (scrollSyncScheduled) return;
    scrollSyncScheduled = true;
    requestAnimationFrame(function () {
      scrollSyncScheduled = false;
      syncChunksAfterScrollRestore();
    });
  }

  function bindIntroRevealScrollSync() {
    if (bindIntroRevealScrollSync._done) return;
    bindIntroRevealScrollSync._done = true;
    window.addEventListener('scroll', scheduleScrollSync, { passive: true, capture: true });
    window.addEventListener('resize', scheduleScrollSync, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', scheduleScrollSync, { passive: true });
      window.visualViewport.addEventListener('resize', scheduleScrollSync, { passive: true });
    }
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncChunksAfterScrollRestore);
  }

  bindIntroRevealScrollSync();
})();
